<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        class="text-none mr-4"
        color="primary"
        elevation="0"
        rounded
        large
        v-on="on"
      >
        <v-icon class="mr-1" small>mdi-plus-circle</v-icon>
        Add Event
      </v-btn>
    </template>
    <v-list class="py-0">
      <v-list-item style="min-height: 34px" @click="redirectToEventCreator"
        >Add Event</v-list-item
      >
      <v-list-item
        style="min-height: 34px"
        @click="redirectToMultipleEventCreator('quick', 'Add Multiple Events')"
        >Add Multiple Events</v-list-item
      >
      <v-list-item
        style="min-height: 34px"
        @click="
          redirectToMultipleEventCreator(
            'import',
            'Import from League Schedule'
          )
        "
        >Import from League Schedule</v-list-item
      >
      <v-list-item
        style="min-height: 34px"
        @click="
          redirectToMultipleEventCreator(
            'spreadsheet',
            'Import from Spreadsheet'
          )
        "
        >Import from Spreadsheet</v-list-item
      >
      <v-list-item
        style="min-height: 34px"
        @click="
          redirectToMultipleEventCreator(
            'aiassistant',
            'Import using AI Assistant'
          )
        "
        >Import using AI Assistant</v-list-item
      >
    </v-list>
  </v-menu>
</template>

<script>
import Vue from "vue";
import { bus } from "@/main";

export default Vue.extend({
  name: "AddEventMenuButton",
  props: {
    teamId: { type: String, required: true },
    limitedFunctionality: { type: Boolean, required: true }
  },
  methods: {
    redirectToEventCreator() {
      if (this.limitedFunctionality) {
        bus.$emit("showExpiredSubscription");
      } else {
        const callback = () => {
          bus.$emit("refetchTeam");
        };
        bus.$emit("loadIframe", {
          title: " ",
          url: `/event/create/${this.teamId}?hideNav=true`,
          callback: callback
        });
        // window.location.href = `/event/create/${this.teamId}`;
      }
    },
    redirectToMultipleEventCreator(frag, title) {
      if (this.limitedFunctionality) {
        bus.$emit("showExpiredSubscription");
      } else {
        const callback = () => {
          bus.$emit("refetchTeam");
        };
        const urlFrag = frag ? `#${frag}` : "";
        bus.$emit("loadIframe", {
          title: title,
          url: `/o/${this.teamId}/addEvents?hideNav=true${urlFrag}`,
          callback: callback
        });
      }
    }
  }
});
</script>

<style scoped></style>
